// CONTEXT
import { TicketsProvider } from "../../contexts/tickets/tickets.context";

// COMPONENTS
import LoggedIn from "../../layouts/loggedIn.layout";
import TicketsPage from "./page.tickets.page";

const TicketsLayout = () => {
  return (
    <LoggedIn>
      <TicketsProvider>
        <TicketsPage />
      </TicketsProvider>
    </LoggedIn>
  );
};

export default TicketsLayout;
